module.exports = __webpack_public_path__ + "3e8bd87f54957af3bbec5da07478a2a0.MP3";